var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 314,
    viewBox: "0 0 436 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M320.4 137H289V173.3H320.4V137Z",
    fill: "#465471"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.399 141.4H292.699V168.8H316.399V141.4Z",
    fill: "#465471"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M363.699 137H332.299V173.3H363.699V137Z",
    fill: "#465471"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.698 141.4H335.998V168.8H359.698V141.4Z",
    fill: "#465471"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M427.655 313.999H8.34464C-2.5889 314.098 -2.97253 306.001 8.34464 306.001H427.655C438.589 305.902 438.973 313.999 427.655 313.999Z",
    fill: "#465471"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.932 58.4887C128.518 42.4032 117.574 27.2673 101.489 24.6817C85.4032 22.0961 70.2673 33.0399 67.6817 49.1254C65.096 65.2109 76.0399 80.3468 92.1253 82.9324C108.211 85.518 123.347 74.5742 125.932 58.4887Z",
    fill: "#465471"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.659 57.2071C121.537 44.5884 112.83 32.8365 100.211 30.9585C87.5926 29.0806 75.8408 37.7877 73.9628 50.4064C72.0849 63.0251 80.792 74.777 93.4107 76.655C106.029 78.5329 117.781 69.8258 119.659 57.2071Z",
    fill: "#97A4BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4783 55.6216C97.4783 57.5216 94.5783 57.5216 94.6783 55.6216C94.5783 53.8216 97.4783 53.8216 97.4783 55.6216Z",
    fill: "#465471"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3655 38.8L95.1602 55.5983L96.86 55.6191L97.0654 38.8207L95.3655 38.8Z",
    fill: "#465471"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2789 65.4216L89.8789 64.5216L95.3789 54.9216L96.8789 55.7216L91.2789 65.4216Z",
    fill: "#465471"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M142 215.6H55V220.9H142V215.6Z",
    fill: "#465471"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M78.5004 182.8H65.9004V215.8H78.5004V182.8Z",
    fill: "#465471"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M105.801 182.8H94.7012V215.8H105.801V182.8Z",
    fill: "#465471"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M130.4 211.7L120.5 216.3L104.6 186.9L114.5 182.2L130.4 211.7Z",
    fill: "#465471"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 170H82V215.8H94.6V170Z",
    fill: "#465471"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.823 304.9H86.6232C82.3232 305 84.1232 297.7 83.7232 295.3C83.7232 293.7 85.0232 292.4 86.6232 292.4H122.723V304.9H122.823Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.822 296.3H84.4219V297H122.822V296.3Z",
    fill: "#97A4BF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.822 298.3H84.4219V299H122.822V298.3Z",
    fill: "#97A4BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.822 302.4H84.4219V303.1H122.822V302.4Z",
    fill: "#97A4BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.822 294.3H84.4219V295H122.822V294.3Z",
    fill: "#97A4BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.822 300.3H84.4219V301H122.822V300.3Z",
    fill: "#97A4BF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.823 305.5H86.7228C81.7228 305.5 83.4228 298.3 83.2228 295.3C83.2228 293.4 84.8228 291.8 86.7228 291.8H122.823V293H86.7228C83.0228 292.9 84.8228 299.8 84.4228 302C84.4228 303.3 85.4228 304.3 86.7228 304.3H122.823V305.5Z",
    fill: "#F18500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.023 303L117.623 300.6L115.223 303V296.3H120.023V303Z",
    fill: "#F18500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M115.724 291.1H79.5236C75.2236 291.2 77.0236 283.9 76.6236 281.5C76.6236 279.9 77.9236 278.6 79.5236 278.6H115.624V291.1H115.724Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.722 282.5H77.3223V283.2H115.722V282.5Z",
    fill: "#97A4BF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.722 284.5H77.3223V285.2H115.722V284.5Z",
    fill: "#97A4BF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.722 288.6H77.3223V289.3H115.722V288.6Z",
    fill: "#97A4BF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.722 280.5H77.3223V281.2H115.722V280.5Z",
    fill: "#97A4BF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.722 286.5H77.3223V287.2H115.722V286.5Z",
    fill: "#97A4BF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.723 291.7H79.6232C74.6232 291.7 76.3232 284.5 76.1232 281.5C76.1232 279.6 77.7232 278 79.6232 278H115.723V279.2H79.6232C75.9232 279.1 77.7232 286 77.3232 288.2C77.3232 289.5 78.3232 290.5 79.6232 290.5H115.723V291.7Z",
    fill: "#EBA154"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.923 289.2L110.523 286.7L108.023 289.2V282.5H112.923V289.2Z",
    fill: "#F18500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M308.699 175.3H329.399C335.799 175.3 340.899 170.1 340.899 163.8V156.6C340.899 150.2 335.699 145.1 329.399 145.1H308.699C302.299 145.1 297.199 150.3 297.199 156.6V163.8C297.199 170.1 302.399 175.3 308.699 175.3Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.398 173.1L315.898 181L321.098 168.4L329.398 173.1Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M305.3 157H332.8C333.3 157 333.6 156.6 333.6 156.2V155.7C333.6 155.2 333.2 154.9 332.8 154.9H305.3C304.8 154.9 304.5 155.3 304.5 155.7V156.2C304.5 156.6 304.9 157 305.3 157Z",
    fill: "#97A4BF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M305.3 161.4H332.8C333.3 161.4 333.6 161 333.6 160.6V160.1C333.6 159.6 333.2 159.3 332.8 159.3H305.3C304.8 159.3 304.5 159.7 304.5 160.1V160.6C304.5 161 304.9 161.4 305.3 161.4Z",
    fill: "#97A4BF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M305.3 165.5H332.8C333.3 165.5 333.6 165.1 333.6 164.7V164.2C333.6 163.7 333.2 163.4 332.8 163.4H305.3C304.8 163.4 304.5 163.8 304.5 164.2V164.7C304.5 165.2 304.9 165.5 305.3 165.5Z",
    fill: "#97A4BF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M274.101 214.2L274.001 306.2H188.401L188.301 214.2C188.701 199.6 200.101 190.5 212.601 187.3C215.901 186.5 219.201 186 222.501 186C223.801 185.9 225.101 185.9 226.501 185.8C228.601 185.7 230.701 185.7 232.901 185.7H233.001C239.201 185.8 245.501 186.4 251.401 187.9C263.301 191.2 273.001 198.5 274.101 214.2Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M251.3 188.1C250.9 190.5 244.2 206.6 231.1 206.6C217.2 206.7 212.6 187.5 212.6 187.5C212.6 187.4 212.6 187.4 212.6 187.3C215.9 186.5 219.2 186 222.5 186C223.8 185.9 225.1 185.9 226.5 185.8C228.7 185.8 230.8 185.7 232.9 185.7H233C238.4 185.7 243.7 186 251.4 187.6C251.3 187.8 251.3 187.9 251.3 188.1Z",
    fill: "#C7CDDA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M221.199 188.6C222.399 202.6 243.699 201.8 243.699 187.6C243.699 182 243.599 172.1 243.599 166.4L223.399 165.6C222.799 172.5 221.399 181.8 221.199 188.6Z",
    fill: "#C7CDDA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.4 185.6C230.1 186.4 239 181.5 243.6 178.4L243.8 175.4L222.5 172.2C222.3 176 221.3 182 221.4 185.6Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M183.399 163.4L183.199 163.2C183.299 163.3 183.399 163.4 183.399 163.4Z",
    fill: "#465471"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M202.401 142.9C213.801 178.4 257.801 177.1 263.901 137C267.701 135.9 272.901 133.3 270.001 131.1C267.001 128.9 261.201 123.8 261.201 123.8C268.901 121.3 270.001 111.7 266.001 113.6C262.001 115.5 256.801 113.7 247.001 109.5C223.201 100 207.901 113.1 202.601 128.9C201.001 133.6 201.001 138.4 202.401 142.9Z",
    fill: "#465471"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M209.6 116.7C209.8 116.5 210 116.3 210.2 116.1C210 116.3 209.8 116.5 209.6 116.7Z",
    fill: "#F18500"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M256.401 150C268.501 133.4 274.801 166.1 257.201 162C251.401 159.9 256.401 150 256.401 150Z",
    fill: "#C7CDDA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M261.202 150.2C263.902 149.6 265.702 157.7 259.702 158.2C260.402 156.5 260.402 154.6 259.502 153L261.202 150.2Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M258.602 159.2C262.102 155.4 259.502 152.8 259.502 152.8C259.502 152.8 262.802 145.9 264.202 151.1",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M209.6 150.5C197.2 134.2 191.5 166.9 209.1 162.5C214.9 160.3 209.6 150.5 209.6 150.5Z",
    fill: "#C7CDDA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M204.901 150.8C202.201 150.2 200.601 158.4 206.601 158.8C205.801 157.1 205.801 155.2 206.601 153.6L204.901 150.8Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M207.6 159.8C204.1 156.1 206.6 153.5 206.6 153.5C206.6 153.5 203.2 146.7 201.9 151.9",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M233.301 181.5C255.201 180.6 256.001 160.4 257.001 143.5C258.301 129.2 247.001 116.8 232.601 117C218.201 117.2 207.101 129.7 208.801 144C210.201 160.9 211.501 181.1 233.301 181.5Z",
    fill: "#C7CDDA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M244 155.5C244 160.9 248 160.8 247.9 155.5C247.8 150.1 243.9 150.1 244 155.5Z",
    fill: "#465471"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220.9 155.7C220.9 161.1 224.9 161 224.8 155.7C224.7 150.3 220.8 150.4 220.9 155.7Z",
    fill: "#465471"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M230.901 173.1C235.801 173.6 241.901 172.5 241.901 166.4L224.201 166.6C224.201 170.2 227.201 173.1 230.901 173.1Z",
    fill: "#F18500"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M236.399 154.2C236.599 166 254.599 165.8 254.499 154C254.299 142.2 236.299 142.4 236.399 154.2Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M211.6 154.5C211.8 166.3 229.8 166.1 229.7 154.3C229.6 142.5 211.6 142.6 211.6 154.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M229.699 155.3C229.699 155.3 233.399 151.9 236.399 155.2",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M224.2 143.6C215.1 145.1 209.6 143.2 217.4 141.2C225.2 139.2 228.9 142.8 224.2 143.6Z",
    fill: "#465471"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M241.1 143.4C250.2 144.8 255.7 142.7 247.8 140.9C240 139.1 236.3 142.7 241.1 143.4Z",
    fill: "#465471"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M232.101 169C234.501 169.2 238.001 168.5 238.701 166.4L227.301 166.5C227.801 168 229.801 169 232.101 169Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M209.701 154.5C212.001 144.2 208.301 129.1 229.401 128.4C241.401 129.3 239.101 139 250.401 141.2C250.401 141.2 257.101 141.3 251.701 133.2C251.701 133.2 258.701 135.6 256.501 152.8C256.501 152.8 263.001 140.8 259.301 134.1C255.601 127.4 250.401 118.7 243.301 116.4C224.601 110.3 211.501 124.8 211.501 124.8C211.501 124.8 204.901 137.9 209.701 154.5Z",
    fill: "#465471"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M211.6 139.8C211.6 139.8 221.2 127.9 237.2 131C237.2 130.9 218.9 112.8 211.6 139.8Z",
    fill: "#465471"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M256.801 139.4C256.801 139.4 254.101 148.8 256.401 156.5C256.401 156.5 259.301 148.4 259.501 142.4C259.601 136.5 256.801 139.4 256.801 139.4Z",
    fill: "#465471"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1 139.9C209.1 139.9 212 149.3 209.9 157C209.9 157 206.8 148.9 206.5 143C206.2 137 209.1 139.9 209.1 139.9Z",
    fill: "#465471"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2 117.1C208.9 117.5 208.6 117.8 208.4 118C208.7 117.8 209 117.4 209.2 117.1Z",
    fill: "#F18500"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M208.301 118.3C208.401 118.2 208.401 118.2 208.501 118.1C208.401 118.2 208.301 118.2 208.301 118.3Z",
    fill: "#F18500"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M212.701 187.3C212.701 187.3 179.801 191.2 159.301 235.1L188.401 248.9C188.401 248.9 211.201 198.1 212.701 187.3Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M251.301 187.8C251.301 187.8 282.301 192.5 298.201 231.5L275.201 248.5C275.201 248.5 252.801 198.6 251.301 187.8Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M270.201 228.1L274.001 248.8L267.301 240.1",
    stroke: "#465471",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M191.9 237.1L188.4 248.5L188.6 228.1",
    stroke: "#465471",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M297.4 232.1C326 310 251.9 266 236 247L240.3 237.2C240.3 237.2 265.6 246 280.4 251.5L278.2 246.4L297.4 232.1Z",
    fill: "#C7CDDA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M291.399 256.6L280.199 251.3",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M241.1 237.5C241.1 237.5 235.6 235.4 227.7 234.4C219.9 233.5 218.3 236.2 218.3 236.2C218.3 236.2 205.7 239.5 201 240.4C196.3 241.4 196.2 245.7 202.8 245.3C209.4 244.9 215.3 244.6 215.3 244.6C215.3 244.6 213.6 249.3 214 250.9C215.9 254.2 228.1 257 229.5 251.5C239.8 256.2 250.4 244.3 241.1 237.5Z",
    fill: "#C7CDDA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M218.4 236.2C218.4 236.2 216.7 240.2 215.4 244.6",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M220.001 241.9C220.201 242 215.201 253 218.501 253.7",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 243.2C223.2 243.5 219.5 253.3 222 254.4",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 251.6C227.9 251 226.9 250.2 226.1 250.1",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M232.7 268.7C237.9 263.8 248.1 270.8 254.6 272.2C260.2 273.8 268.1 280 271.1 282.3C272.2 283.1 277.3 284.5 274.8 287.5C274.1 288.1 272.5 287.7 271.9 287.5C271.3 287.3 270.9 287.5 270.2 287.4C269.5 287.3 268.2 286.6 268.1 286.5C265.6 287.7 258 284.6 254.5 284.2C249.1 284.6 233.8 283.6 232.1 277.5C230.1 272.7 231.8 269.6 232.7 268.7Z",
    fill: "#C7CDDA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M268.1 286.5C268.1 286.5 270 284.5 266.8 283.1C263.5 281.7 254 278.2 254 278.2",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M271.6 287.5C276.1 283.4 267.7 281.5 262.6 279.1C259 277.4 256.5 276.1 256.5 276.1",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M271.1 282.3C271.1 282.3 261.1 275.8 258.4 274.6",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M250.801 206.6C250.801 206.6 232.201 229.9 211.301 205.4",
    stroke: "#465471",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M234.6 280.7L239.4 267.2C239.4 267.2 185.8 259.6 184.7 255.4C183.6 253.3 186.4 248 186.7 248.1L161.1 236C161.1 236 140.6 297.4 234.6 280.7Z",
    fill: "#C7CDDA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 255.4L174.9 250",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M182.301 306.8C182.301 306.9 303.201 306.8 303.301 306.8C306.201 306.8 308.401 304.4 308.401 301.7C309.001 300.3 310.101 296.8 310.701 295.3C337.301 219.4 341.101 244.6 243.001 240.3C240.401 240.3 238.001 242 237.101 244.5L231.301 260.9C231.301 261 216.901 301.7 216.801 301.8H182.601C179.601 301.7 179.001 306.5 182.301 306.8Z",
    fill: "#F18500"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M216.9 301.7H308.4",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M270.701 269.8C267.401 279.6 279.601 283.7 283.001 274C286.301 264.2 274.101 260 270.701 269.8Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M194.3 129.7H194.292L194.284 129.7L181.884 130.1L181.47 130.114L181.406 130.523L180.069 139.08L171.473 129.467L171.322 129.298L171.096 129.3L116.5 129.7C116.499 129.7 116.499 129.7 116.498 129.7C113.798 129.699 111.5 127.347 111.5 124.4V56.8C111.5 53.8468 113.705 51.5 116.5 51.5H194.4C197.09 51.5 199.3 53.8406 199.3 56.8V124.4C199.3 127.353 197.095 129.7 194.3 129.7Z",
    fill: "white",
    stroke: "#465471"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M151.799 122.8C151.899 127.7 144.199 127.7 144.199 122.8C144.199 117.9 151.899 117.9 151.799 122.8Z",
    fill: "#F18500"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 122.2H145.6V123.4H150.5V122.2Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M162.4 122.8C162.5 127.7 154.8 127.7 154.8 122.8C154.7 117.9 162.4 117.9 162.4 122.8Z",
    fill: "#465471"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M159.899 125H157.299C157.299 123.6 156.999 122.1 158.999 122.4C160.199 122.4 159.799 124.2 159.899 125Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M159.499 121.1C159.499 122.3 157.599 122.3 157.699 121.1C157.599 119.9 159.499 119.9 159.499 121.1Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M161.099 122.2H160.599V122.7H160.199V122.2H159.699V121.8H160.199V121.3H160.599V121.8H161.099V122.2Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M194.2 59.6V112.3C194.2 114.2 192.7 115.8 190.7 115.8H120.1C118.2 115.8 116.6 114.3 116.6 112.3V59.5C116.6 57.6 118.1 56 120.1 56H190.8C192.7 56.1 194.2 57.6 194.2 59.6Z",
    fill: "#F18500"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M134.399 115.7H130.799L131.199 113.2L134.399 115.7Z",
    fill: "#C7CDDA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M131.199 113.2L134.299 115.8H131.799C131.499 115 131.299 114.1 131.199 113.2Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 115.7H173.7L172.1 115.1V108.6C173 109.9 176.4 114.5 177.2 115.7Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M163.198 74.6C163.198 74.6 164.298 87.4999 162.398 93.7999H140.398C141.298 83.7999 141.998 72.2 141.998 72.2L163.198 74.6Z",
    fill: "#465471"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M144.398 75.9C144.298 80.2 143.198 91.8 141.998 93.8H160.498C160.498 93.8 163.098 88 162.098 81.4C161.098 74.8 144.398 73.5 144.398 75.9Z",
    fill: "#465471"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M167.598 103.2C167.398 106.2 166.998 112.8 166.898 115.7C166.698 115.7 139.298 115.7 139.098 115.7C139.298 108.6 136.198 94.4 145.398 92.2C147.698 91.3 153.198 91.7 155.698 91.6C161.998 91.5 167.598 96.9 167.598 103.2Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M152.398 98C145.898 97.5 145.398 92.1 145.398 92.1C149.098 91 153.598 92.1 156.898 91.6C156.898 91.6 157.898 91.7 159.398 92C159.398 92 158.998 98.5 152.398 98Z",
    fill: "#C7CDDA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M148.398 91.9C148.898 96.7 156.398 96.1 156.098 91.3C155.998 89.4 155.898 86 155.798 84H148.898C148.798 86.4 148.398 89.5 148.398 91.9Z",
    fill: "#C7CDDA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M163.198 74.6C162.898 88.6 142.298 88.1 141.998 74.5C141.998 71.5 142.298 69.4 145.498 67.1C148.898 59.2 163.598 64.4 163.198 74.6Z",
    fill: "#465471"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M155.998 88.5L156.098 90.8C156.098 90.8 150.298 91.7 148.498 89.4L148.598 88.4L155.998 88.5Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M160.698 78.9C165.198 73.3 166.598 84.8 160.798 83C158.798 82.2 160.698 78.9 160.698 78.9Z",
    fill: "#C7CDDA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M162.299 79C163.199 78.8 163.799 81.6 161.699 81.7C161.999 81.1 161.999 80.5 161.699 79.9L162.299 79Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M161.299 82.1C162.499 80.8 161.699 79.9 161.699 79.9C161.699 79.9 162.899 77.6 163.299 79.4",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M144.599 78.6C140.299 72.8 138.499 84.2 144.299 82.7C146.299 82 144.599 78.6 144.599 78.6Z",
    fill: "#C7CDDA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M142.999 78.5999C142.099 78.3999 141.399 81.1999 143.499 81.3999C143.199 80.7999 143.299 80.1999 143.599 79.5999L142.999 78.5999Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M143.798 81.7C142.598 80.4 143.498 79.5 143.498 79.5C143.498 79.5 142.398 77.1 141.898 78.9",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4 89.5001C159.9 89.4001 160.4 82.5001 160.9 76.7001C161.5 71.8001 157.7 67.5001 152.8 67.4001C147.9 67.3001 143.9 71.5001 144.4 76.4001C144.7 82.1001 144.9 89.1001 152.4 89.5001Z",
    fill: "#C7CDDA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M151.198 86.5C152.998 86.5 155.798 86.9999 155.498 84.2999L149.398 84.2C149.298 85.4 149.998 86.5 151.198 86.5Z",
    fill: "#F18500"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M149.698 75.5C146.598 75.9 144.698 75.2 147.398 74.6C150.098 74 151.298 75.2 149.698 75.5Z",
    fill: "#465471"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M155.499 75.6C158.599 76.2 160.499 75.5 157.799 74.8C155.199 74.1 153.899 75.3 155.499 75.6Z",
    fill: "#465471"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 85.2001C152.898 85.3001 154.098 85.1001 154.398 84.4001L150.498 84.3C150.698 84.8 151.298 85.1001 152.098 85.2001Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M144.898 70.0001C144.898 70.0001 146.498 74.2001 151.398 74.6001C152.498 74.5001 153.298 73.9001 151.798 72.0001C154.598 73.9001 160.498 76.7001 157.998 69.8001C157.998 69.8001 160.498 77.5001 161.998 76.1001C163.498 74.7001 161.098 68.3001 156.398 66.8001C151.698 65.2001 146.198 65.8001 144.898 70.0001Z",
    fill: "#465471"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M144.099 75.6C144.099 75.6 145.199 78.6 144.299 80.4C140.999 77.3 143.299 71.9 144.099 75.6Z",
    fill: "#465471"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M160.699 76.9C160.699 76.9 159.999 79.6 160.799 81.4C163.899 77.8 161.799 72.9 160.699 76.9Z",
    fill: "#465471"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M145.998 70.8C145.998 70.8 145.998 73.6001 144.398 75.6001C143.298 77.0001 142.898 70.8 145.998 70.8Z",
    fill: "#465471"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M155.6 79.1C155.6 80.9 156.9 81 156.9 79.1C157 77.3 155.6 77.3 155.6 79.1Z",
    fill: "#465471"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M147.699 79C147.699 80.8 148.999 80.9 148.999 79C149.099 77.1 147.699 77.1 147.699 79Z",
    fill: "#465471"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M145.199 92.4C144.599 97.6 141.099 109.1 139.299 115.7C139.499 115.7 134.399 115.7 134.399 115.7C133.399 114.9 130.799 112.7 129.799 112C132.999 104.7 136.299 94.2 145.199 92.4Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M179.898 109C178.898 110.3 175.598 114.5 174.598 115.7H171.098C170.698 115.3 166.698 112.2 166.898 111.5C163.898 105.2 161.698 98.6 160.498 92.4C165.298 93.7 169.398 97.2 171.398 101.8L179.898 109Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M181.398 115.7H175.598C170.898 110.4 167.798 102.8 164.898 95.7C165.598 95.3 166.998 94.5 167.698 94.1C167.898 94.3 184.898 108.6 181.398 115.7Z",
    fill: "#C7CDDA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M165.498 109.1L166.898 111.2L167.198 105.9",
    stroke: "#465471",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M145.398 98.7C145.398 98.7 152.698 104.1 159.998 98.7",
    stroke: "#465471",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M167.698 94.1C167.698 93.8 162.398 89.5 161.298 90.7C161.298 90.7 157.398 90.1 155.998 89.8C154.598 89.5 153.998 90.7 155.898 91.4C157.798 92.1 159.498 92.7 159.498 92.7C159.498 92.7 158.498 93.8 158.398 94.3C158.698 95.5 161.398 97.6 162.598 96.3C164.398 98.6 169.398 96.9 167.698 94.1Z",
    fill: "#C7CDDA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M161.299 90.7C161.299 90.7 160.299 91.6 159.499 92.7C159.499 92.7 156.199 91.6 155.099 90.9C154.399 90.3 154.799 89.5 156.099 89.9",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M159.398 92.7C158.498 93.4 157.598 94.8 159.198 95.6C158.398 95 160.998 92.5 160.998 92.5",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M161.798 93.2001C161.698 93.3001 159.498 95.5001 160.098 96.1001",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M162.499 96.3C162.099 95.9 161.899 95.6 161.699 95.5",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M132.999 77.2999C127.599 77.3999 120.199 78.3 120.499 70.5C120.699 63.5 128.099 64.4999 132.999 64.5999C140.799 64.3999 140.799 77.3999 132.999 77.2999Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M125.398 76.3999L131.098 79.6999L128.898 74.3999L125.398 76.3999Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M135.399 69.6C135.099 69.4 123.199 70.1 123.599 69.2C122.899 68.1 135.299 69 135.399 68.7C135.999 68.6 135.999 69.6 135.399 69.6Z",
    fill: "#97A4BF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M135.399 71.4C135.099 71.2 123.199 71.9 123.599 71C122.899 69.9 135.299 70.8 135.399 70.5C135.999 70.5 135.999 71.4 135.399 71.4Z",
    fill: "#97A4BF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M135.399 73.1999C135.099 72.9999 123.199 73.6999 123.599 72.7999C122.899 71.6999 135.299 72.5999 135.399 72.2999C135.999 72.2999 135.999 73.1999 135.399 73.1999Z",
    fill: "#97A4BF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M292.343 88.2498L282.6 98.1768V88.6V88.0967L282.097 88.1L267.1 88.2C267.099 88.2 267.099 88.2 267.098 88.2C264.006 88.1988 261.5 85.5547 261.5 82.2V6.5C261.5 3.14457 264.007 0.5 267.1 0.5H354.4C357.388 0.5 359.9 3.139 359.9 6.5V82.2C359.9 85.5552 357.394 88.1996 354.301 88.2C354.301 88.2 354.3 88.2 354.3 88.2L292.701 88.1L292.49 88.0997L292.343 88.2498Z",
    fill: "white",
    stroke: "#465471"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M306.6 80.4C306.7 85.9 298 85.9 298.1 80.4C298.1 74.9 306.7 74.9 306.6 80.4Z",
    fill: "#F18500"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M305.201 79.8H299.701V81.1H305.201V79.8Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M318.401 80.4C318.501 85.9 309.801 85.9 309.901 80.4C309.901 74.9 318.501 74.9 318.401 80.4Z",
    fill: "#465471"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M315.601 82.9H312.701C312.701 81.2 312.201 79.7 314.601 80C316.101 79.9 315.501 82.1 315.601 82.9Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M315.202 78.5C315.202 79.8 313.102 79.8 313.102 78.5C313.102 77.2 315.302 77.2 315.202 78.5Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M317.002 79.8H316.402V80.4H316.002V79.8H315.402V79.4H316.002V78.8H316.402V79.4H317.002V79.8Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M353.4 9.59995V68.5999C353.4 70.7 351.7 72.5 349.5 72.5H270.3C268.2 72.5 266.4 70.7999 266.4 68.5999V9.59995C266.4 7.49995 268.1 5.69995 270.3 5.69995H349.5C351.7 5.69995 353.4 7.39995 353.4 9.59995Z",
    fill: "#F18500"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M339.899 72.4H330.199V62L337.799 63.8C338.299 65.1 339.499 69.8 339.899 72.4Z",
    fill: "#C7CDDA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M293.399 62V72.5H284.199C284.499 70.1 284.799 68.2 285.099 66.7C285.099 66.6 293.399 62 293.399 62Z",
    fill: "#C7CDDA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M330.299 57C330.299 61.1 330.299 68.3 330.299 72.4H293.399V71.9V61.9C292.699 55.3 294.899 48 301.799 45.9C311.899 43.7 329.299 43.2 330.299 57Z",
    fill: "#465471"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M312.199 50.8999C318.199 50.8999 320.699 45.8999 320.499 45.5999C315.099 44.3999 312.499 44.8999 307.999 44.7999C307.999 44.7999 306.199 45.0999 303.899 45.4999C303.799 45.4999 306.199 50.9999 312.199 50.8999Z",
    fill: "#C7CDDA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M307.4 45.7C307.9 51.3 316.9 50.7 316.5 45C316.4 42.7 316.3 38.7 316.2 36.4H308C307.9 39.1 307.4 42.9 307.4 45.7Z",
    fill: "#C7CDDA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M291.2 35.2L291.1 35.1L291.2 35.2C291.2 35.1 291.2 35.1 291.2 35.2Z",
    fill: "#465471"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M299.501 23C302.201 40.2 322.101 41.2 325.201 24C326.801 23.6 325.201 14 318.601 12.6C309.901 8.89997 305.401 12.8 302.701 15.6C302.701 15.6 301.801 16.8 301.401 17.5C299.701 19 298.801 20.8 299.501 23Z",
    fill: "#465471"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M322.001 29.2C327.301 22.6 329.101 36.1 322.201 34.1C319.801 33.2 322.001 29.2 322.001 29.2Z",
    fill: "#C7CDDA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M323.901 29.3C325.001 29.1 325.601 32.4 323.201 32.5C323.501 31.8 323.501 31 323.201 30.4L323.901 29.3Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M322.801 33C324.301 31.5 323.201 30.4 323.201 30.4C323.201 30.4 324.601 27.6 325.101 29.8",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M302.9 28.8C297.8 22 295.6 35.4 302.5 33.7C304.9 32.9 302.9 28.8 302.9 28.8Z",
    fill: "#C7CDDA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M301 28.9C299.9 28.6 299.1 31.9 301.6 32.2C301.3 31.5 301.3 30.7 301.7 30.1L301 28.9Z",
    fill: "#97A4BF",
    fillOpacity: 0.4
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M302.001 32.6C300.601 31 301.701 30 301.701 30C301.701 30 300.401 27.2 299.801 29.3",
    stroke: "#97A4BF",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M312.199 41.6999C321.099 41.5999 321.699 33.3999 322.299 26.4999C322.999 20.6999 318.499 15.4999 312.699 15.3999C306.799 15.2999 302.199 20.2999 302.699 26.0999C302.999 33.0999 303.299 41.2999 312.199 41.6999Z",
    fill: "#C7CDDA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M316.301 29.5C316.201 31.7 317.801 31.7 317.901 29.5C317.901 27.3 316.301 27.3 316.301 29.5Z",
    fill: "#465471"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M306.901 29.3C306.801 31.5 308.401 31.5 308.501 29.3C308.501 27.1 306.901 27.1 306.901 29.3Z",
    fill: "#465471"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M310.3 38.3C312.5 38.2 316.3 39.3 315.8 35.7L308.6 35.6C308.5 36.8 308.9 38.3 310.3 38.3Z",
    fill: "#F18500"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M309.001 25.1C305.301 25.6 303.101 24.8 306.301 24C309.401 23.4 310.901 24.9 309.001 25.1Z",
    fill: "#465471"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M315.801 25.3C319.501 26 321.701 25.2 318.601 24.3C315.401 23.5 313.901 24.9 315.801 25.3Z",
    fill: "#465471"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M311.8 36.7C312.8 36.8 314.2 36.6 314.5 35.7L309.9 35.6C310.1 36.2 310.9 36.6 311.8 36.7Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M302.9 28.7999C303.6 25.5999 303.6 16.1999 311.3 18.3999C316.6 20.4999 323.1 21.6999 322.1 28.5999C322.1 28.5999 324.9 23.7999 323.5 20.9999C322.1 18.1999 320.1 14.4999 317.2 13.5999C314.3 12.6999 304.1 16.6999 304.1 16.6999C304.1 16.6999 301.2 21.9999 302.9 28.7999Z",
    fill: "#465471"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M303.9 22.9C303.9 22.9 308 18.2 314.4 19.6C314.4 19.6 307.2 12 303.9 22.9Z",
    fill: "#465471"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 24.9C322.3 24.9 321.1 28.7 321.9 31.9C321.9 32 324.9 23.3 322.3 24.9Z",
    fill: "#465471"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M302.801 24.5C302.801 24.5 303.901 28.3 302.901 31.5C302.901 31.6 300.301 22.9 302.801 24.5Z",
    fill: "#465471"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M301.8 46C301.8 46 289.9 46 282.1 66.6L293.3 71.9C293.4 72 301.2 50.6 301.8 46Z",
    fill: "#465471"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M321.6 46C321.6 46 334.1 47.4 340.6 65.8L330.2 72.4C330.3 72.4 322.3 50.6 321.6 46Z",
    fill: "#465471"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302 48.2999C302 48.2999 312.4 60.0999 321.6 48.2999",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M295.7 64.2999L293.4 71.9999V68.3999",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.2 64.9L330.1 72L328.1 70.4",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5 31.1C337.1 31.1 328.4 32.5 328.2 24.6C327.7 20.6 330.4 16.6 334.7 16.7H342.6C351.1 16.6 351.2 31.2 342.5 31.1Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M340.1 30.4V33.9L344.9 29.2L340.1 30.4Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M344.999 22.4C344.799 22.2 331.099 23 331.599 21.9C330.799 20.6 344.899 21.6 344.999 21.3C345.699 21.3 345.699 22.4 344.999 22.4Z",
    fill: "#97A4BF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M344.999 24.4999C344.799 24.2999 331.099 25.0999 331.599 23.9999C330.799 22.6999 344.899 23.6999 344.999 23.3999C345.699 23.3999 345.699 24.4999 344.999 24.4999Z",
    fill: "#97A4BF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M344.999 26.4999C344.799 26.2999 331.099 27.0999 331.599 25.9999C330.799 24.6999 344.899 25.6999 344.999 25.3999C345.699 25.3999 345.699 26.4999 344.999 26.4999Z",
    fill: "#97A4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetClass);
export default __webpack_public_path__ + "static/media/meet_class.d9a1544d9ebb0582c65c0fbd2f02c544.svg";
export { ForwardRef as ReactComponent };